const SaveFavouriteLockerIcon = ({ width = "20px", height = "20px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    width={width}
    height={height}
  >
    <g fill="#319D10">
      <path d="M10 2.5c4.13 0 7.5 3.38 7.5 7.5 0 4.13-3.38 7.5-7.5 7.5A7.52 7.52 0 0 1 2.5 10c0-4.13 3.38-7.5 7.5-7.5Zm0-1.25A8.78 8.78 0 0 0 1.25 10 8.78 8.78 0 0 0 10 18.75 8.78 8.78 0 0 0 18.75 10 8.78 8.78 0 0 0 10 1.25Z" />
      <path d="M15 9.38h-4.38V5H9.38v4.38H5v1.24h4.38V15h1.24v-4.38H15V9.38Z" />
    </g>
  </svg>
);

export default SaveFavouriteLockerIcon;
